<template>
  <div style="width: 600px">
    <h2>个人中心</h2>
    <el-form label-width="100px">
      <el-form-item label="账号: ">
        <span> {{ dataForm.username }} </span>
      </el-form-item>
      <el-form-item label="角色: ">
        <span> {{ getRoleName(dataForm.userType) }} </span>
      </el-form-item>
      <el-form-item label="所属机构: ">
        <span> {{ dataForm.orgName }} </span>
      </el-form-item>
      <el-form-item label="邀请码: ">
        <span> {{ dataForm.inviteCode || "--" }} </span>
      </el-form-item>
      <el-form-item label="邀请名额: ">
        <span> {{ dataForm.inviteQuota || "--" }} </span>
      </el-form-item>
      <el-form-item label="手机号: ">
        <el-input type="text" v-model="dataForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="昵称: ">
        <el-input type="text" v-model="dataForm.nickName"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名: ">
        <el-input type="text" v-model="dataForm.realName"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱: ">
        <el-input type="text" v-model="dataForm.email"></el-input>
      </el-form-item>
      <el-form-item label="QQ: ">
        <el-input type="text" v-model="dataForm.qq"></el-input>
      </el-form-item>
      <el-form-item label="详细地址: ">
        <el-input type="text" v-model="dataForm.address"></el-input>
      </el-form-item>
      <el-form-item label="性别: ">
        <el-radio-group v-model="dataForm.gender">
          <el-radio label="MAN">男</el-radio>
          <el-radio label="WOMAN">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateMy" :loading="loading"
          >更新</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dataForm: {},
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    // 获取当前用户信息
    getUserInfo() {
      this.$http({
        url: this.$http.adornUrl("sys/user/my"),
        method: "get",
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm = data.user;
        }
      });
    },
    updateMy() {
      this.loading = true;
      this.$http({
        url: this.$http.adornUrl("sys/user/updateMy"),
        method: "put",
        data: this.dataForm,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message.success("个人信息修改成功！");
          this.getUserInfo();
        } else {
          this.$message.error(data.msg);
        }
        this.loading = false;
      });
    },
    getRoleName(userType) {
      // P_MANAGER(平台管理人员);O_MANAGER(机构管理人员);TEACHER(教师);STUDENT(学生);TOURIST(游客)
      switch (userType) {
        case "STUDENT":
          return "学生";
        case "TEACHER":
          return "教师";
        case "O_MANAGER":
          return "机构管理人员";
        case "P_MANAGER":
          return "平台管理人员";
        default:
          return "游客";
      }
    },
  },
};
</script>

<style>
</style>